import { jsx } from "react/jsx-runtime";
import "react";
import { IconButton } from "../IconButton/index.js";
import { Icon } from "../Icon/index.js";
import { Tooltip } from "../Tooltip/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const CopyButton = ({ valueToCopy, onClick, onReject, size = '24', iconName = 'copy_outline', iconColor = 'original.brand.primary', tooltip, disabled, testId = 'copy-button-test-id' })=>{
    const handleCopy = (value)=>(e)=>_async_to_generator(function*() {
                e.stopPropagation();
                if (disabled) return;
                try {
                    yield navigator.clipboard.writeText(value);
                    null == onClick || onClick();
                } catch (error) {
                    null == onReject || onReject();
                }
            })();
    return /*#__PURE__*/ jsx(Tooltip, {
        title: null == tooltip ? void 0 : tooltip.text,
        placement: null == tooltip ? void 0 : tooltip.placement,
        disabled: !tooltip,
        children: /*#__PURE__*/ jsx(IconButton, {
            type: "button",
            size: "small",
            testId: testId,
            onClick: handleCopy(valueToCopy),
            children: /*#__PURE__*/ jsx(Icon, {
                name: iconName,
                color: iconColor,
                size: size
            })
        })
    });
};
export { CopyButton };
